/* Wo Lamhe – "Build your magazine" step flow */
(function () {
  var root = document.querySelector('[data-wl-builder]');
  if (!root) return;
  var dataEl = root.querySelector('script[data-wlb]');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);

  var optsEl = root.querySelector('[data-wlb-options]');
  var totalEl = root.querySelector('[data-wlb-total]');
  var shipEl = root.querySelector('[data-wlb-ship]');
  var addBtn = root.querySelector('[data-wlb-add]');
  var errEl = root.querySelector('[data-wlb-err]');
  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-wlb-addon]'));

  var style = null;
  var sel = [];

  function fmt(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function optionLabel(name) {
    if (/priority/i.test(name)) return 'Need it early?';
    if (/page/i.test(name)) return 'How many pages?';
    return name;
  }

  function valueLabel(name, value) {
    var isSpeed = /priority/i.test(name) || /priority/i.test(value) || /^(no|standard)\b/i.test(value);
    if (isSpeed) {
      if (/priority/i.test(value)) return { t: '⚡ Priority', s: 'Draft in 24 hrs · next-day dispatch' };
      return { t: 'Standard', s: 'Ships in 1–2 days · no extra cost' };
    }
    var m = String(value).match(/^\s*(\d+)\s*(?:\((.*)\))?/);
    var PH = { '8': '20–25 photos', '12': '30–35 photos', '16': '40–45 photos' };
    if (m) return { t: m[1] + ' pages', s: PH[m[1]] || (m[2] ? m[2].replace(/\s+/g, ' ').trim() : '') };
    return { t: value, s: '' };
  }

  function findVariant(options) {
    for (var i = 0; i < style.variants.length; i++) {
      var v = style.variants[i];
      var ok = true;
      for (var k = 0; k < options.length; k++) {
        if (v.options[k] !== options[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function uniqueValues(index) {
    var seen = [];
    style.variants.forEach(function (v) {
      if (seen.indexOf(v.options[index]) === -1) seen.push(v.options[index]);
    });
    return seen;
  }

  function hasRealOptions() {
    return !(style.options.length === 1 && style.variants.length === 1);
  }

  function defaultSelection() {
    // Prefer 12 pages + standard speed when available, else first available variant
    var best = null;
    style.variants.forEach(function (v) {
      if (!v.available || best) return;
      var p = String(v.options[0] || '');
      var speedOk = v.options.length < 2 || !/priority/i.test(v.options[1]);
      if (/^\s*12\b/.test(p) && speedOk) best = v;
    });
    if (!best) {
      style.variants.forEach(function (v) {
        if (!best && v.available) best = v;
      });
    }
    return (best || style.variants[0]).options.slice();
  }

  function renumber(firstAddonStep) {
    root.querySelectorAll('[data-wlb-later-num]').forEach(function (el, i) {
      el.textContent = String(firstAddonStep + i);
    });
  }

  function renderOptions() {
    var html = '';
    var step = 2;
    if (hasRealOptions()) {
      style.options.forEach(function (name, i) {
        html += '<fieldset class="wl-b__step"><legend class="wl-b__legend"><span class="wl-b__num">' + step + '</span>' + esc(optionLabel(name)) + '</legend><div class="wl-b__pills">';
        uniqueValues(i).forEach(function (val, j) {
          var trial = sel.slice();
          trial[i] = val;
          var v = findVariant(trial);
          var lab = valueLabel(name, val);
          var id = 'wlb-o' + i + '-' + j;
          var price = '';
          if (v) {
            if (i === 0) price = '<span class="wl-b__pill-p">' + fmt(v.price) + '</span>';
            else {
              var base = findVariant(sel);
              var diff = base ? v.price - base.price : 0;
              if (diff > 0) price = '<span class="wl-b__pill-p">+' + fmt(diff) + '</span>';
            }
          }
          var tag = i === 0 && /^\s*12\b/.test(val) ? '<span class="wl-b__tag">Most popular</span>' : '';
          html += '<input class="wl-b__radio" type="radio" name="wlb-o' + i + '" id="' + id + '" value="' + esc(val) + '" data-index="' + i + '"' + (sel[i] === val ? ' checked' : '') + (v && v.available ? '' : ' disabled') + '>' +
            '<label class="wl-b__pill" for="' + id + '">' + tag + '<span class="wl-b__pill-t">' + esc(lab.t) + '</span>' + (lab.s ? '<span class="wl-b__pill-s">' + esc(lab.s) + '</span>' : '') + price + '</label>';
        });
        html += '</div></fieldset>';
        step++;
      });
    }
    optsEl.innerHTML = html;
    renumber(step);
  }

  /* ---------- add-on rows ---------- */

  function rowOn(row) {
    var cb = row.querySelector('input[type=checkbox]');
    return !!(cb && cb.checked && !cb.disabled);
  }

  function variantSelect(row) {
    return row.querySelector('select[data-variant-select]');
  }

  function rowPrice(row) {
    var s = variantSelect(row);
    if (s && s.selectedOptions[0] && s.selectedOptions[0].dataset.price) return Number(s.selectedOptions[0].dataset.price);
    return Number(row.dataset.price || 0);
  }

  function rowItem(row) {
    var s = variantSelect(row);
    var id = s ? s.value : row.dataset.id;
    if (!id) return null;
    var item = { id: Number(id), quantity: 1 };
    var props = {};
    row.querySelectorAll('[data-prop]').forEach(function (el) {
      var v = el.tagName === 'SELECT' ? (el.selectedOptions[0] ? el.selectedOptions[0].text : '') : el.value;
      v = String(v || '').trim();
      if (v) props[el.dataset.prop] = v;
    });
    if (Object.keys(props).length) item.properties = props;
    var photos = window.WLPhotos ? window.WLPhotos.files(row) : null;
    if (photos) item._photos = photos;
    return item;
  }

  function refreshRowLabel(row) {
    var s = variantSelect(row);
    if (!s || !s.selectedOptions[0]) return;
    var o = s.selectedOptions[0];
    var now = row.querySelector('[data-now]');
    var was = row.querySelector('[data-was]');
    if (now && o.dataset.price) now.textContent = fmt(Number(o.dataset.price));
    if (was && o.dataset.was) was.textContent = fmt(Number(o.dataset.was));
  }

  function syncSet() {
    var setRow = root.querySelector('[data-wlb-set]');
    if (!setRow) return;
    var setOn = setRow.querySelector('input[type=checkbox]').checked;
    rows.forEach(function (row) {
      if (!row.hasAttribute('data-in-set')) return;
      var cb = row.querySelector('input[type=checkbox]');
      if (setOn) {
        cb.checked = false;
        row.classList.remove('is-on');
      }
      cb.disabled = setOn;
      row.classList.toggle('is-muted', setOn);
    });
  }

  function addonsTotal() {
    var t = 0;
    rows.forEach(function (row) {
      if (rowOn(row)) t += rowPrice(row);
    });
    return t;
  }

  function update() {
    var v = style ? findVariant(sel) : null;
    var total = (v ? v.price : 0) + addonsTotal();
    totalEl.textContent = v ? fmt(total) : '—';
    if (!v) shipEl.textContent = 'Choose a style to see your total';
    else if (total >= data.freeAt) shipEl.textContent = 'Free express delivery included';
    else shipEl.textContent = 'Add ' + fmt(data.freeAt - total) + ' more for free express delivery';
    addBtn.disabled = !(v && v.available);
    errEl.textContent = '';
  }

  function chooseStyle(id) {
    style = null;
    data.styles.forEach(function (s) {
      if (String(s.id) === String(id)) style = s;
    });
    if (!style) return;
    sel = defaultSelection();
    renderOptions();
    update();
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'wlb-style') {
      chooseStyle(t.value);
      return;
    }
    if (t.dataset && t.dataset.index !== undefined && style) {
      var idx = Number(t.dataset.index);
      sel[idx] = t.value;
      if (!findVariant(sel)) {
        var alt = null;
        style.variants.forEach(function (v) {
          if (!alt && v.available && v.options[idx] === t.value) alt = v;
        });
        if (alt) sel = alt.options.slice();
      }
      renderOptions();
      update();
      return;
    }
    var row = t.closest ? t.closest('[data-wlb-addon]') : null;
    if (!row) return;
    if (t.type === 'checkbox') {
      row.classList.toggle('is-on', t.checked);
      if (row.hasAttribute('data-wlb-set')) syncSet();
    }
    if (t.matches && t.matches('select[data-variant-select]')) refreshRowLabel(row);
    update();
  });

  addBtn.addEventListener('click', function () {
    var v = style ? findVariant(sel) : null;
    if (!v) return;
    var main = { id: v.id, quantity: 1 };
    var need = root.querySelector('[data-wl-needby]');
    if (need && need.dataset.need) main.properties = { 'Needed by': need.dataset.need, 'Dispatch by': need.dataset.ship };
    var items = [main];
    rows.forEach(function (row) {
      if (!rowOn(row)) return;
      var it = rowItem(row);
      if (it) items.push(it);
    });

    if (window.WLPhotos && window.WLPhotos.busy(root)) {
      errEl.textContent = 'Your polaroid photos are still being prepared — tap again in a moment.';
      return;
    }
    var photoItems = items.filter(function (i) { return i._photos; });
    items = items.filter(function (i) { return !i._photos; });

    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var label = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    var photoChain = photoItems.reduce(function (p, it) {
      return p.then(function () {
        return window.WLPhotos.addItem(it, it._photos).then(function (d) {
          if (d && d.status) throw new Error(d.description || d.message || 'Could not add the polaroids.');
        });
      });
    }, Promise.resolve());
    if (photoItems.length) addBtn.textContent = 'Uploading photos…';
    photoChain
      .then(function () {
        addBtn.textContent = 'Adding…';
        return fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (res) {
        if (res.status) {
          errEl.textContent = res.description || res.message || 'Something went wrong. Please try again.';
          return;
        }
        document.dispatchEvent(new CustomEvent('wl:builder-added'));
        if (drawer && res.sections) drawer.renderContents(res);
        else window.location = window.routes.cart_url;
      })
      .catch(function (e) {
        errEl.textContent = (e && e.message && !/fetch/i.test(e.message)) ? e.message : 'Something went wrong. Please try again.';
      })
      .finally(function () {
        addBtn.textContent = label;
        addBtn.disabled = !(style && findVariant(sel));
      });
  });

  window.WLBuilder = {
    root: root,
    // Tick one ready combo (and clear the other combo rows) — used by the homepage popup
    preset: function (key) {
      var target = key ? root.querySelector('#wlb-c-' + key) : null;
      rows.forEach(function (row) {
        if (!row.hasAttribute('data-in-set') && !row.hasAttribute('data-wlb-set')) return;
        var cb = row.querySelector('input[type=checkbox]');
        if (!cb || !target || cb === target) return;
        if (cb.checked) {
          cb.checked = false;
          row.classList.remove('is-on');
        }
      });
      syncSet();
      if (target && !target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      update();
    },
  };

  rows.forEach(refreshRowLabel);
  var checked = root.querySelector('input[name="wlb-style"]:checked');
  if (checked) chooseStyle(checked.value);
  else update();
})();
